<suite-rfb-collapse title="Reserva e Bloqueio" [collapsed]="this.collapsed" (collapsedChange)="this.onCollapsedChange($event)">
  <suite-rfb-alert-messages-with-datetime [onlyFor]="this.scopeId"></suite-rfb-alert-messages-with-datetime>
  <ng-container *ngIf="this.reservaBloqueioLista?.length > 0; else loadingOrError">
    <div class="table-responsive">
      <table suiteRfbTable>
        <caption>Valores Reservados/Bloqueados</caption>
        <thead>
          <tr>
            <th class="text-center min-width">Valor Reservado</th>
            <th class="text-center min-width">Valor Bloqueado</th>
            <th class="text-center min-width">Sistema</th>
            <th class="text-center min-width">Processo/Perdcomp</th>
            <th class="text-center min-width">Motivo Bloqueio</th>
            <th class="text-center min-width">CPF Usuário</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let reservaBloqueio of this.reservaBloqueioLista">
            <tr class="vertical-align-middle">
              <td class="text-center min-width text-nowrap">
                {{ reservaBloqueio.valorReservado | formatCurrency | vazio }}
              </td>
              <td class="text-center min-width text-nowrap">
                {{ reservaBloqueio.valorBloqueado | formatCurrency | vazio }}
              </td>
              <td class="text-center min-width text-nowrap">
                {{ reservaBloqueio.sistema | vazio }}
              </td>
              <td class="text-center min-width text-nowrap">
                {{ reservaBloqueio.processo | padStart:17:"0" | vazio }}
              </td>
              <td class="text-center min-width text-nowrap">
                {{ reservaBloqueio.motivoBloqueio | vazio }}
              </td>
              <td class="text-center min-width text-nowrap">
                {{ reservaBloqueio.cpfUsuario | formatCpfPipe | vazio }}
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </ng-container>
</suite-rfb-collapse>

<ng-template #loadingOrError>
  <div *ngIf="initError; else loading">
  </div>
  <ng-template #loading>
    <loading-animation *ngIf="!stopLoading"></loading-animation>
  </ng-template>
</ng-template>